import React, { useEffect, useRef, useState } from "react";
import { YesNoRendererComponent } from "../yes-no-renderer.component";
import { useConfirm } from "../../../hooks/useConfirm";
import PaginationContainer from "../form/pagination/container/pagination.container";
import { FilterDrawerComponent } from "./filter-drawer";
import { ProductActionMenus } from "./action-menus";
interface TableActions {
	onSelect?: (onSelectRows: any[]) => void; // Callback for row selection
	// onSelectAll?: () => void; // Callback for "Select All" action
	onViewList?: (row: any) => void;
	onEdit?: (row: any) => void; // Callback for edit action
	onDelete?: (row: any) => void; // Callback for delete action
	onSearch?: (query: string) => void; // Callback for search action
}

interface TablePagination {
	paginationData?: any; // Pagination data (define more specifically if possible)
	setPageData?: (page: number) => void; // Function to update page data
	setPageSize?: (size: number) => void; // Function to update page size
}

interface TableFilters {
	enableFilter?: boolean; // Enable or disable filter
	searchCriteriaList?: any[]; // List of search criteria
	filterTypeLists?: any[]; // List of filter types
	filterBy?: string; // Current filter value
	handleInputChange?: (input: any, fiedl: any, row: any) => void; // Handle filter input changes
}

interface EditableTableProps extends TableActions, TablePagination, TableFilters {
	rowData: any[];
	columnData: any[];
	headingName: string; // Table heading
	onSubmitUpdatedRows?: (updatedRows: any[]) => void; // Save Updated Rows
	taxonamy?: any;
	// Extra Buttons
	additionButtons?: any[];
	IsMoreActionButtonsProducts?: boolean;
	showWithoutAccountMappedButton?: boolean;
	showBulkupdate?: boolean; 
	isEditable?: boolean; 
	// Product actions
	handleExportProducts?: () => void;
	handleAddAttribute?: () => void;
	handleUploadProductClick?: () => void;
	handleAddTagsProducts?: () => void;
	handleProductImportTemplate?: () => void;
	handlePublishProducts?: () => void;
	handleOpenWithoutMapping?: () => void;
	handlePublishSCPGlobalCatalogDBNBiz?: (data: any) => void | Promise<void>;
	handlePublishSCPDBNBiz?: (data: any) => void | Promise<void>;
	showPublishOptionsSCP?: boolean;
}

const MultiSelectDropdown = ({
	options,
	setSelectedRow,
	rowIdx,
	setActiveRow,
	initialSelected = [],
	onClose,
}: any) => {
	const [isOpen, setIsOpen] = useState(false);
	const [selected, setSelected] = useState<{ name: string; code: string }[]>(initialSelected);
	const dropdownRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		setSelected(initialSelected);
		setActiveRow(rowIdx);
	}, [rowIdx]);

	useEffect(() => {
		function handleClickOutside(event: any) {
			if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
				setIsOpen(false);
				onClose?.(selected);
			}
		}
		document.addEventListener("mousedown", handleClickOutside);
		return () => document.removeEventListener("mousedown", handleClickOutside);
	}, [selected]);

	const toggleDropdown = () => setIsOpen(!isOpen);

	const handleOptionClick = (option: { name: string; code: string }) => {
		const exists = selected.find(item => item.code === option.code);
		if (exists) {
			setSelected(selected?.filter(item => item.code !== option.code));
		} else {
			setSelected([...selected, option]);
		}
	};
	const removeTag = (option: { name: string; code: string }) => {
		setSelected(selected?.filter(item => item.code !== option.code));
	};

	return (
		<div className="relative w-72" ref={dropdownRef}>
			<div
				className="border border-gray-300 rounded px-3 py-2 cursor-pointer bg-white"
				onClick={toggleDropdown}
			>
				<div className="flex flex-wrap gap-2">
					{selected?.length === 0 ? (
						<span className="text-gray-400">Select options</span>
					) : (
						selected?.map((item) => (
							<span
								key={item.code}
								className="bg-blue-100 text-blue-800 text-sm px-2 py-1 rounded-full flex items-center"
							>
								{item.name}
								<button
									onClick={(e) => {
										e.stopPropagation();
										removeTag(item);
									}}
									className="ml-1 text-blue-600 hover:text-red-600"
								>
									&times;
								</button>
							</span>
						))
					)}
				</div>
			</div>

			{isOpen && (
				<ul className="absolute z-10 mt-1 w-full bg-white border border-gray-300 rounded shadow max-h-60 overflow-auto">
					{options?.length === 0 ? (
						<li className="px-4 py-2 text-gray-500 text-center">No data found</li>
					) : (
						options?.map((option: any) => (
							<li
								key={option.code}
								onClick={() => handleOptionClick(option)}
								className={`px-4 py-2 hover:bg-blue-100 cursor-pointer ${selected.find((item) => item.code === option.code) ? "bg-blue-50 font-semibold" : ""
									}`}
							>
								{option.name}
								{selected.find((item) => item.code === option.code) && (
									<span className="float-right">✔</span>
								)}
							</li>
						))
					)}
				</ul>
			)}
		</div>
	);
};

const EditableTable = ({
	rowData, columnData, headingName,
	onSubmitUpdatedRows,
	additionButtons, onEdit, onViewList, onDelete,
	paginationData, setPageData, setPageSize,
	enableFilter = false, filterTypeLists, filterBy,
	handleInputChange,
	searchCriteriaList, onSearch = () => { },
	IsMoreActionButtonsProducts,
	handleExportProducts,
	handleAddAttribute,
	handleUploadProductClick,
	handleAddTagsProducts,
	handleProductImportTemplate,
	handlePublishProducts,
	handlePublishSCPGlobalCatalogDBNBiz,
	handlePublishSCPDBNBiz,
	showPublishOptionsSCP,
	taxonamy,
	showWithoutAccountMappedButton,
	handleOpenWithoutMapping,
	showBulkupdate,
	isEditable
}: EditableTableProps) => {
	const [data, setData] = useState(rowData || []);
	const originalDataRef = useRef(JSON.parse(JSON.stringify(rowData)));

	const [anchorShipmentEl, setAnchorShipmentEl] = useState(null);
	// if rowData can change:
	// useEffect(() => {
	// 	setData(rowData);
	// 	originalDataRef.current = JSON.parse(JSON.stringify(rowData));
	// }, [rowData]);

	const [selectedRow, setSelectedRow] = useState([])
	const [selectedCategories, setSelectedCategories]: any = useState([])
	const [filterOptions, setFilterOptions] = useState([])
	const [activeRow, setActiveRow] = useState(null)

	const [isSaving, setIsSaving] = useState(false);
	const [selectedOption, setSelectedOption] = useState("");
	const [selectedColumn, setSelectedColumn] = useState("");
	const [editing, setEditing] = useState({ row: null, column: null });
	const { confirm, modal } = useConfirm();
	const [showFilter, setShowFilter] = useState(false);
	const [filteredData, setFilteredData] = useState<any>(rowData || []);

	const [taxonamyData, setTaxonamyData] = useState([]);

	const getNestedValue = (obj, path) => {
		return path
			.replace(/\[(\w+)\]/g, ".$1") // convert [0] to .0
			.split(".")
			.reduce((o, key) => (o && o[key] !== undefined ? o[key] : undefined), obj);
	};

	const handleEdit = (rowIdx: number, field: string) => {
		setEditing({ row: rowIdx, column: field });
	};

	const handleView = (item: any) => {
		onViewList(item)
	}

	const handleEditAction = (item: any) => {
		onEdit(item)
	}

	const handleClickDelete = async (data: any) => {
		const isConfirmed = await confirm('Are you sure you want to delete ?');
		if (isConfirmed) {
			handleDelete(data)
		}
	};

	const handleDelete = (item: any) => {
		onDelete(item)
	}

	// const handleChange = (e: any, rowIdx: any, column: any) => {
	// 	const newData: any = [...data];
	// 	newData[rowIdx][column] = e.target.value;
	// 	newData[rowIdx]["isUpdated"] = true;
	// 	setData(newData);
	// };

	const handleCategories = (rowIdx: any) => {
		// const newData: any = [...data];
		const newData: any = [...filteredData];
		if (rowIdx != null) {
			newData[rowIdx]['DBNCategories'] = selectedCategories
			newData[rowIdx]["isUpdated"] = true;
		}
		// setData(newData);
		setFilteredData(newData);
	}

	const handleChange = (e: any, rowIdx: any, column: any) => {
		if (column != "DBNCategories") {
			const newData: any = [...filteredData];
			newData[rowIdx][column] = e.target.value
			newData[rowIdx]["isUpdated"] = true;
			// setData(newData);
			setFilteredData(newData);
		}
	};

	const handleKeyDown = (e: any) => {
		if (e.key === "Enter") {
			setEditing({ row: null, column: null });
		}
	};

	useEffect(() => {
		setFilteredData([...rowData])
	}, [rowData]);

	useEffect(() => {
		console.log(selectedOption)
	}, [selectedOption])

	// useEffect(() => {
	// 	setData(rowData || []);
	// }, [rowData]);

	useEffect(() => {
		console.log(selectedColumn)
	}, [selectedColumn])

	// useEffect(() => {
	// 	let arr: any = taxonamy?.Records[0]?.DBNTaxonomies
	// 	setTaxonamyData(arr)
	// 	console.log(arr)
	// }, [taxonamy])

	useEffect(() => {
		if (taxonamy) {
			let arr: any = taxonamy?.Records[0]?.DBNTaxonomies;
			setTaxonamyData(arr);
			console.log(arr);
		}
	}, [taxonamy]);

	useEffect(() => {
		let domain: any = []
		domain = taxonamyData?.filter((item: any) => item?.EdgeDBNDomainName)
		let categories: any = []
		selectedRow?.map((obj: any) => {
			categories.push(domain[0]?.EdgeDBNCategories?.filter((item: any) => item?.EdgeDBNCategoryName == obj)[0])
		})
		setSelectedCategories(categories)
		// handleCategories(activeRow)
	}, [selectedRow])

	useEffect(() => {
		handleCategories(activeRow)
	}, [selectedCategories]);

	const getValue = (obj, path) => {
		return path.split('.').reduce((acc, part) => {
			const arrayMatch = part.match(/(\w+)\[(\d+)\]/);
			if (arrayMatch) {
				return acc?.[arrayMatch[1]]?.[parseInt(arrayMatch[2], 10)];
			}
			return acc?.[part];
		}, obj);
	};

	const hasRowUpdates = filteredData?.some(row => row.isUpdated === true);

	// Save All Handler (e.g., inside top action bar)
	const handleSaveAllUpdatedRows = async () => {
		const updatedRows = filteredData?.filter((row) => row.isUpdated);
		if (!onSubmitUpdatedRows || updatedRows.length === 0) return;
		setIsSaving(true);
		try {
			await onSubmitUpdatedRows(updatedRows);
			// Cleardata: after saved the rows
			// const clearedData = originalDataRef.current?.map(row => ({ ...row, isUpdated: false }));
			const clearedData = originalDataRef.current?.map((row) => {
				const newRow = { ...row };
				delete newRow._isDirty;
				newRow.isUpdated = false;
				return newRow;
			});
			// setData(clearedData);
			setFilteredData(clearedData);
		} catch (err) {
			console.error("Save failed", err);
		} finally {
			setIsSaving(false);
		}
	};

	const handleClearRowUpdate = (rowIdx: number) => {
		const cleared = [...filteredData];
		cleared[rowIdx] = {
			...originalDataRef.current?.[rowIdx],
			isUpdated: false,
		};
		// setData(cleared);
		setFilteredData(cleared);
	};

	const [searchTerms, setSearchTerms] = useState<{ [key: string]: string }>({});
	const [menuField, setMenuField] = useState<string | null>(null);
	const [dateFilter, setDateFilter] = useState<string>('all');
	const [customStartDate, setCustomStartDate] = useState<string>('');
	const [customEndDate, setCustomEndDate] = useState<string>('');
	const menuRef = useRef<HTMLDivElement | null>(null);

	const [dateField, setDateField] = useState<string>('CreatedOnUtc'); // default field
	const [fromDate, setFromDate] = useState<Date | null>(null);
	const [toDate, setToDate] = useState<Date | null>(null);

	// Store initial visible columns
	const originalColumnsRef = useRef(
		columnData?.map(col => ({ ...col, visible: true }))
	);

	// State for current column visibility
	const [columnDataHide, setColumnDataHide] = useState(
		originalColumnsRef.current
	);

	// Handle string filter changes
	const handleFilterChange = (label: string, value: string) => {
		const updated = { ...searchTerms, [label]: value };
		setSearchTerms(updated);

		const newData = rowData.filter((row: any) => {
			return columnData.every((col: any) => {
				if (!col.filterType || !updated[col.label]) return true;

				const filterVal = updated[col.label];
				const cellVal = getNestedValue(row, col.field);

				if (col.filterType === 'text') {
					return (cellVal || "")
						.toString()
						.toLowerCase()
						.includes(filterVal.toLowerCase());
				}

				if (col.filterType === 'select') {
					return cellVal === filterVal;
				}

				if (col.filterType === 'multiselect') {
					const selectedCodes = filterVal.split(',');
					const actualCodes = (cellVal || [])?.map((c: any) => c?.EdgeDBNCategoryCode);
					return selectedCodes.every(code => actualCodes.includes(code));
				}

				if (col.filterType === 'boolean') {
					if (filterVal === 'true') return cellVal === true;
					if (filterVal === 'false') return cellVal === false;
					return true;
				}

				return true;
			});
		});

		// setData(newData);
		setFilteredData(newData);
	};

	// Toggle filter menu visibility
	const toggleMenu = (field: string, event: React.MouseEvent) => {
		event.stopPropagation();
		setMenuField(prev => (prev === field ? null : field));
	};

	// Hide a specific column
	const handleField = (fieldName) => {
		setColumnDataHide(prev =>
			prev?.map(col =>
				col.field === fieldName ? { ...col, visible: false } : col
			)
		);
	};

	// Reset all hidden columns to visible
	const resetHiddenColumns = () => {
		setColumnDataHide(originalColumnsRef.current);
	};

	// Show a hidden column by label
	const showColumn = (label: string) => {
		setColumnDataHide(prev =>
			prev?.map(col =>
				col.label === label ? { ...col, visible: true } : col
			)
		);
	};

	// Triggered on dropdown change
	const handleDateFilterChange = (filter: string) => {
		setDateFilter(filter);
		if (filter !== 'custom') {
			applyDateFilter(filter, customStartDate, customEndDate);
		}
	};

	// Apply the actual filter
	const applyDateFilter = (filter: string, start: string = '', end: string = '') => {
		let fromDate: Date | null = null;
		let toDate: Date | null = null;
		const now = new Date();

		switch (filter) {
			case "today":
				fromDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
				toDate = new Date(now);
				toDate.setHours(23, 59, 59, 999);
				break;
			case "last1week":
				fromDate = new Date(now);
				fromDate.setDate(now.getDate() - 7);
				toDate = new Date(now);
				toDate.setHours(23, 59, 59, 999);
				break;
			case "last1month":
				fromDate = new Date(now);
				fromDate.setMonth(now.getMonth() - 1);
				toDate = new Date(now);
				toDate.setHours(23, 59, 59, 999);
				break;
			case "last1year":
				fromDate = new Date(now);
				fromDate.setFullYear(now.getFullYear() - 1);
				toDate = new Date(now);
				toDate.setHours(23, 59, 59, 999);
				break;
			case "custom":
				if (start && end && !isNaN(new Date(start).getTime()) && !isNaN(new Date(end).getTime())) {
					fromDate = new Date(start);
					toDate = new Date(end);
					toDate.setHours(23, 59, 59, 999);
				} else {
					// setData(rowData);
					setFilteredData(rowData);
					return;
				}
				break;
			default:
				// Only apply column filters
				const onlyColumnFiltered = rowData.filter((row: any) =>
					columnDataHide.every((col: any) => {
						if (!col.filterType || !searchTerms[col.label]) return true;

						const filterVal = searchTerms[col.label];
						const cellVal = getNestedValue(row, col.field);

						if (col.filterType === 'text') {
							return (cellVal || "").toString().toLowerCase().includes(filterVal.toLowerCase());
						}

						if (col.filterType === 'select') {
							return cellVal === filterVal;
						}

						if (col.filterType === 'multiselect') {
							if (!Array.isArray(cellVal)) return false;
							const selectedCodes = filterVal.split(',').filter(Boolean);
							const actualCodes = cellVal?.map((c: any) => c?.EdgeDBNCategoryCode);
							return selectedCodes.every(code => actualCodes.includes(code));
						}

						if (col.filterType === 'boolean') {
							if (filterVal === 'true') return cellVal === true;
							if (filterVal === 'false') return cellVal === false;
							return true;
						}

						return true;
					})
				);
				// setData(onlyColumnFiltered);
				setFilteredData(onlyColumnFiltered);
				return;
		}

		// Date filter
		// const filteredByDate = rowData.filter((row: any) => {
		// 	const rowDate = new Date(getNestedValue(row, 'CreatedOnUtc'));
		// 	if (!fromDate || !toDate || isNaN(rowDate.getTime())) return false;
		// 	return rowDate >= fromDate && rowDate <= toDate;
		// });
		const filteredByDate = rowData.filter((row: any) => {
			const fieldValue = getNestedValue(row, dateField); // uses selected field
			const rowDate = new Date(fieldValue);

			if (!fromDate || !toDate || isNaN(rowDate.getTime())) return false;

			return rowDate >= fromDate && rowDate <= toDate;
		});

		// Column filter after date filter
		const fullyFiltered = filteredByDate.filter((row: any) =>
			columnDataHide.every((col: any) => {
				if (!col.filterType || !searchTerms[col.label]) return true;

				const filterVal = searchTerms[col.label];
				const cellVal = getNestedValue(row, col.field);

				if (col.filterType === 'text') {
					return (cellVal || "").toString().toLowerCase().includes(filterVal.toLowerCase());
				}

				if (col.filterType === 'select') {
					return cellVal === filterVal;
				}

				if (col.filterType === 'multiselect') {
					if (!Array.isArray(cellVal)) return false;
					const selectedCodes = filterVal.split(',').filter(Boolean);
					const actualCodes = cellVal?.map((c: any) => c?.EdgeDBNCategoryCode);
					return selectedCodes.every(code => actualCodes.includes(code));
				}

				if (col.filterType === 'boolean') {
					if (filterVal === 'true') return cellVal === true;
					if (filterVal === 'false') return cellVal === false;
					return true;
				}

				return true;
			})
		);

		// setData(fullyFiltered);
		setFilteredData(fullyFiltered);
	};

	// Close menu on outside click
	useEffect(() => {
		const handleClickOutside = (event: MouseEvent) => {
			if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
				setMenuField(null);
			}
		};
		document.addEventListener("mousedown", handleClickOutside);
		return () => document.removeEventListener("mousedown", handleClickOutside);
	}, []);


	return (
		<div className="overflow-auto p-4">
			{/* Heading Name - Buttons Table*/}
			<div className="flex my-2  w-full justify-between items-center px-2">
				<div className="uppercase text-xl">
					{headingName ? headingName : ''}
				</div>
				<div className=' flex flex-row items-end justify-end text-end '>
					{additionButtons?.length && additionButtons?.map((button: any) => (
						<button
							onClick={(event) => button.callback(event)}
							type="button"
							className={`group flex items-center mr-2 bg-blue-700 text-white rounded font-medium px-2 py-2
												${button.disabled ? 'opacity-50 cursor-not-allowed bg-blue-500 text-gray-400' : ''}`}
							title={button.name === "Add Default" ? "Add Default web pages for all the vendors" : ""}
							disabled={button.disabled} // Ensure button is disabled when necessary
						>
							<span className=''>{button.svg}</span>
							<span className=''>{button.name}</span>
						</button>
					))}

					{enableFilter &&
						<button
							onClick={() => setShowFilter(!showFilter)}
							type="button"
							className="group flex items-center bg-blue-700 text-white rounded font-medium px-2 py-2"
						>
							<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
								<title>Search and Filters</title>
								<path d="M2.73224 5.32873C1.58574 4.03892 2.50136 2 4.22706 2H19.7734C21.4991 2 22.4147 4.03893 21.2682 5.32873L15.0002 12.3802V21C15.0002 21.3466 14.8208 21.6684 14.5259 21.8507C14.2311 22.0329 13.863 22.0494 13.553 21.8944L9.553 19.8944C9.21421 19.725 9.00021 19.3788 9.00021 19V12.3802L2.73224 5.32873ZM19.7734 4H4.22706L10.7476 11.3356C10.9103 11.5187 11.0002 11.7551 11.0002 12V18.382L13.0002 19.382V12C13.0002 11.7551 13.0901 11.5187 13.2528 11.3356L19.7734 4Z" stroke="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" />
							</svg>
						</button>}
					<div className='px-2'>
						{/* {IsMoreActionButtonsProducts &&
							<ProductActionMenus setAnchorShipmentEl={setAnchorShipmentEl} anchorShipmentEl={anchorShipmentEl} handleExportProducts={handleExportProducts} handleAddAttribute={handleAddAttribute} handleUploadProductClick={handleUploadProductClick} handleAddTagsProducts={handleAddTagsProducts} handlePublishProducts={handlePublishProducts} handleProductImportTemplate={handleProductImportTemplate} handlePublishSCPGlobalCatalogDBNBiz={handlePublishSCPGlobalCatalogDBNBiz} handlePublishSCPDBNBiz={handlePublishSCPDBNBiz} showPublishOptionsSCP={showPublishOptionsSCP} />
						} */}
					</div>
				</div>
				{enableFilter && <FilterDrawerComponent
					columnData={columnData}
					rowData={rowData}
					filterTypeLists={filterTypeLists}
					searchCriteriaList={searchCriteriaList}
					setFilteredData={setFilteredData}
					initiateSearch={onSearch}
					showFilter={showFilter}
					setShowFilter={setShowFilter}
				/>}
			</div>
			{/* Bulk update toolbar */}
			{showBulkupdate && data?.length !== 0 && (
				<div className="flex flex-wrap justify-between items-center gap-4 rounded-xl border my-2 px-4 py-3 bg-white text-sm text-gray-600 mx-auto w-full">

					{/* Left: Bulk update mode */}
					<div className="flex flex-wrap items-center gap-4">
						<strong className="whitespace-nowrap">Bulk Update Mode:</strong>

						{/* Row mode */}
						<label className="inline-flex items-center gap-1">
							<input
								type="radio"
								name="updateMode"
								value="row"
								checked={selectedOption === "row"}
								onChange={(e) => {
									setSelectedOption(e.target.value);
									setSelectedColumn('');
								}}
								className="form-radio text-blue-600"
							/>
							<span className="text-gray-700">Row item</span>
						</label>

						{/* Column mode */}
						<label className="inline-flex items-center gap-1">
							<input
								type="radio"
								name="updateMode"
								value="column"
								checked={selectedOption === "column"}
								onChange={(e) => {
									setSelectedOption(e.target.value);
									setSelectedColumn('');
								}}
								className="form-radio text-blue-600"
							/>
							<span className="text-gray-700">Specific column</span>
						</label>

						{/* Column dropdown */}
						{selectedOption === "column" && (
							<div className="flex items-center gap-2">
								<strong className="text-xs text-gray-500">Select column to update:</strong>
								<select
									value={selectedColumn}
									onChange={(e) => {
										const selected = e.target.value;
										setSelectedColumn(selected);
										setColumnDataHide(prev =>
											prev?.map(col =>
												col.label === selected && !col.visible
													? { ...col, visible: true }
													: col
											)
										);
									}}
									className="text-xs p-1 border border-gray-300 rounded-md shadow-sm"
								>
									<option value="">-- Select a column --</option>
									{columnData
										.filter(col => col?.selectAColumnList)
										.map(col => (
											<option key={col?.label} value={col?.label}>
												{col?.label}
											</option>
										))}
								</select>
							</div>
						)}

						{/* Current selection info + clear */}
						{selectedOption && (
							<>
								<div className="text-xs text-gray-500">
									<strong>Current Selection:</strong> {selectedOption}
									{selectedOption === "column" && selectedColumn && <> → {selectedColumn}</>}
								</div>

								<button
									onClick={() => {
										setSelectedOption("");
										setSelectedColumn("");
									}}
									className="px-2 py-1 border border-gray-300 rounded bg-gray-100 hover:bg-gray-200 text-xs"
								>
									Reset Selection
								</button>
							</>
						)}
					</div>

					{/* Right: Filters / show columns / save-clear */}
					<div className="flex flex-wrap items-center gap-3">
						{/* Without Mapping Button */}
						{showWithoutAccountMappedButton && (
							<button
								onClick={handleOpenWithoutMapping}
								className="flex items-center gap-1 px-2 py-1 border border-blue-300 rounded-md bg-blue-100 hover:bg-blue-200 text-blue-800 text-xs font-medium"
							>
								<svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
									<path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
										d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2l-7 8v4l-2 2v-6L3 6V4z" />
								</svg>
								Without Account Mapped
							</button>
						)}

						{/* Show hidden column selector */}
						{columnDataHide?.some(col => !col.visible) && (
							<>
								<div className="flex items-center gap-2">
									<strong className="text-xs text-gray-500">Reveal Hidden Column:</strong>
									<select
										className="text-xs border border-gray-300 rounded px-2 py-1 bg-white"
										onChange={(e) => {
											const selected = e.target.value;
											if (selected) showColumn(selected);
										}}
									>
										<option value="">-- Select hidden column --</option>
										{columnDataHide
											.filter(col => !col.visible)
											.map(col => (
												<option key={col.field} value={col.label}>
													{col.label}
												</option>
											))}
									</select>
								</div>

								<button
									onClick={resetHiddenColumns}
									className="px-2 py-1 border border-gray-300 rounded bg-gray-100 hover:bg-gray-200 text-xs"
								>
									Restore All Columns
								</button>
							</>
						)}

						{/* Save/Clear block */}
						{hasRowUpdates && (
							<div className="flex items-center gap-2">
								<strong className="text-xs text-gray-500">Pending Updates:</strong>

								<button
									onClick={handleSaveAllUpdatedRows}
									disabled={isSaving}
									className={`flex items-center gap-1 px-2 py-1 border rounded-md text-xs font-medium ${isSaving
										? "border-gray-400 bg-gray-200 text-gray-600 cursor-not-allowed"
										: "border-green-600 bg-green-100 hover:bg-green-200 text-green-800"
										}`}
								>
									{isSaving ? (
										<>
											<svg className="animate-spin h-4 w-4 mr-1 text-green-700" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
												<circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
												<path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
											</svg>
											Saving...
										</>
									) : (
										<>
											<svg xmlns="http://www.w3.org/2000/svg" className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
												<path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
											</svg>
											Apply Changes ({filteredData?.filter(row => row.isUpdated).length})
										</>
									)}
								</button>

								<button
									onClick={() => {
										const cleared = originalDataRef.current?.map(row => ({
											...row,
											isUpdated: false,
										}));
										// setData(cleared);
										setFilteredData(cleared);
									}}
									className="flex items-center gap-1 px-2 py-1 border border-red-300 rounded-md bg-red-100 hover:bg-red-200 text-red-800 text-xs font-medium"
								>
									<svg xmlns="http://www.w3.org/2000/svg" className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
										<path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
									</svg>
									Discard Changes ({filteredData?.filter(row => row.isUpdated).length})
								</button>
							</div>
						)}
					</div>
				</div>
			)}

			{/* Table or No Data */}
			{data?.length === 0 ? (
				<div className='w-full mt-4 flex justify-center items-center text-start text-xl p-6 border-2 border-gray-300 rounded-lg'>
					No data available on this page.
				</div>
			) : (
				<>
					{/* Table */}
					<div className="overflow-auto max-h-96 w-full z-50">
						<table className="min-w-full text-sm bg-white border border-gray-200 rounded-lg shadow-sm">
							<thead className="sticky top-0 z-10 bg-slate-700 text-white">
								<tr>
									<th className="py-3 px-4">S.No</th>
									{/* {columnData?.map((col: any) => col.visible ? ( */}
									{(columnDataHide || [])?.map((col: any) =>
										col.visible ? (
											<th key={col.field} className="py-3 px-4 text-left relative">
												<div className="flex items-center justify-between">
													<span className="truncate text-white font-medium">{col.label}</span>
													{col.filterType && (
														<button onClick={(e) => toggleMenu(col.label, e)} className="ml-2 px-1 text-white" title="Filter options">
															⋮
														</button>
													)}
												</div>
												{menuField === col.label && (
													<div ref={menuRef} className="absolute top-full right-0 mt-1 w-64 bg-white text-slate-800 border border-slate-400 p-3 shadow-xl z-20 rounded">
														{col.filterType === 'text' ? (
															<div className="mb-3 relative">
																<input
																	type="text"
																	placeholder={`Search by ${col.label}...`}
																	className="w-full h-8 pr-14 pl-2 text-sm border border-slate-300 rounded bg-slate-100 text-slate-800 focus:outline-none focus:ring-2 focus:ring-blue-400"
																	value={searchTerms[col.label] || ""}
																	onChange={(e) => handleFilterChange(col.label, e.target.value)}
																/>

																{/* Clear Button - only show when there's a value */}
																{searchTerms[col.label] && (
																	<button
																		type="button"
																		className="absolute right-8 top-1.5 text-xs text-red-500 underline hover:text-red-700"
																		onClick={() => handleFilterChange(col.label, "")}
																	>
																		Clear
																	</button>
																)}

																{/* Search icon */}
																<span className="absolute right-2 top-1.5 text-slate-600">🔍</span>
															</div>

														) : col.filterType === 'select' ? (
															<select
																className="w-full p-2 text-sm rounded border border-slate-400 bg-white text-slate-800 focus:outline-none focus:ring-2 focus:ring-blue-400"
																value={searchTerms[col.label] || ""}
																onChange={(e) => handleFilterChange(col.label, e.target.value)}
															>
																<option value="">All Options</option>
																{taxonamyData?.map((domain: any, idx: number) => (
																	<option key={idx} value={domain?.EdgeDBNDomainName}>
																		{domain?.EdgeDBNDomainName}
																	</option>
																))}
															</select>
														) : col.filterType === 'multiselect' ? (
															<div className="mb-3 relative">
																<select
																	multiple
																	className="w-full h-28 p-2 text-sm rounded border border-slate-400 bg-white text-slate-800 focus:outline-none focus:ring-2 focus:ring-blue-400"
																	value={searchTerms[col.label]?.split(',') || []}
																	onChange={(e) => {
																		const selected = Array.from(e.target.selectedOptions, option => option.value);
																		handleFilterChange(col.label, selected.join(','));
																	}}
																>
																	{Array.from(new Set(
																		taxonamyData?.flatMap((domain: any) =>
																			domain?.EdgeDBNCategories?.map((cat: any) => `${cat.EdgeDBNCategoryCode}:::${cat.EdgeDBNCategoryName}`)
																		).filter(Boolean)
																	)).map((entry: string, idx: number) => {
																		const [code, name] = entry.split(':::');
																		return (
																			<option key={idx} value={code}>
																				{name} ({code})
																			</option>
																		);
																	})}
																</select>
																<button
																	type="button"
																	className="absolute right-7 bottom-1 text-xs text-red-500 underline hover:text-red-700"
																	onClick={() => handleFilterChange(col.label, "")}
																>
																	Clear
																</button>
															</div>
														) : col.filterType === 'date' ? (
															<div className="mb-3">
																<select
																	className="w-full p-2 text-sm rounded border border-slate-400 bg-white text-slate-800 focus:outline-none focus:ring-2 focus:ring-blue-400"
																	value={dateFilter}
																	onChange={(e) => handleDateFilterChange(e.target.value)}
																>
																	<option value="all">All</option>
																	<option value="today">Today</option>
																	<option value="last1week">Last 1 Week</option>
																	<option value="last1month">Last 1 Month</option>
																	<option value="last1year">Last 1 Year</option>
																	<option value="custom">Custom Range</option>
																</select>

																{dateFilter === 'custom' && (
																	<div className="mt-2 space-y-2">
																		<input
																			type="date"
																			value={customStartDate}
																			onChange={(e) => setCustomStartDate(e.target.value)}
																			className="w-full p-2 text-sm border rounded border-slate-300 text-slate-800"
																		/>
																		<input
																			type="date"
																			value={customEndDate}
																			onChange={(e) => setCustomEndDate(e.target.value)}
																			className="w-full p-2 text-sm border rounded border-slate-300 text-slate-800"
																		/>

																		<div className="flex justify-between gap-2 pt-1.5">
																			<button
																				type="button"
																				className="w-full py-1.5 text-sm bg-blue-500 text-white rounded hover:bg-blue-600 disabled:opacity-40"
																				// onClick={() => applyDateFilter('custom', customStartDate, customEndDate)}
																				onClick={() => {
																					applyDateFilter('custom', customStartDate, customEndDate);
																					setDateFilter('custom-applied');
																				}}
																				disabled={!customStartDate || !customEndDate}
																			>
																				Apply
																			</button>
																			<button
																				type="button"
																				className="w-full py-1.5 text-sm bg-red-100 text-red-600 border border-red-400 rounded hover:bg-red-200"
																				onClick={() => {
																					setCustomStartDate('');
																					setCustomEndDate('');
																					// setDateFilter('all');
																					applyDateFilter('all');
																				}}
																			>
																				Clear
																			</button>
																		</div>
																	</div>
																)}
															</div>
														) : col.filterType === "boolean" ? (
															<div className="mb-3 relative">
																<select
																	className="w-full p-2 text-sm rounded border border-slate-400 bg-white text-slate-800 focus:outline-none focus:ring-2 focus:ring-blue-400"
																	value={searchTerms[col.label] || ""}
																	onChange={(e) => handleFilterChange(col.label, e.target.value)}
																>
																	<option value="">All</option>
																	<option value="true">True</option>
																	<option value="false">False</option>
																</select>
																{searchTerms[col.label] && (
																	<button
																		type="button"
																		className="absolute right-7 bottom-1 text-xs text-red-500 underline hover:text-red-700"
																		onClick={() => handleFilterChange(col.label, "")}
																	>
																		Clear
																	</button>
																)}
															</div>
														) : null}

														<div className="text-right pt-2">
															<button
																className="text-xs text-blue-500 underline hover:text-blue-700"
																// onClick={() => handleField(col?.field)}
																onClick={() => {
																	handleField(col?.field);
																	setMenuField(null); // Close the menu
																}}
															>
																Hide this column
															</button>
														</div>
													</div>
												)}
											</th>
										) : null)}
									{(onEdit || onDelete || onViewList) && (
										<th className="py-2 px-4 text-center">Action</th>
									)}
								</tr>
							</thead>
							<tbody>
								{/* {data && data.length > 0 ? (
									data?.map((row: any, rowIdx: any) => ( */}
								{filteredData && filteredData.length > 0 ? (
									filteredData?.map((row, rowIdx) => (
										<tr
											key={row.id || rowIdx}
											className={row.isUpdated ? "border-b bg-[#4285F4]" : "border-b even:bg-[#F8F9FAFF] odd:bg-white"}
										>
											<td className="py-2 px-4 border text-center">{rowIdx + 1}</td>

											{/* Begin column loop */}
											{(columnDataHide || [])?.map((column: any, index: any) => column.visible ? (
												<td
													key={column?.label}
													className={`py-2 px-4 cursor-pointer border border-x border-y ${column?.isEdit ? 'underline cursor-pointer' : ''} ${selectedColumn === column?.label ? "bg-[#4285F4]" : ""}`}
													onClick={() => handleEdit(rowIdx, column?.field)}
												>
													{isEditable && editing.row === rowIdx && editing.column === column?.field && column?.type !== "image" && column?.type !== "boolean" ? (
														column?.field === "EdgeDBNDomainName" ? (
															getNestedValue(row, "EdgeDBNDomainName") && !row._isDirty ? (
																// Show as plain text if domain is set and not dirty
																<span
																	className="cursor-default"
																	title={`The domain "${getNestedValue(row, "EdgeDBNDomainName")}" has been configured for the product "${getNestedValue(row, "Name")}" and cannot be modified.`}
																>
																	{getNestedValue(row, "EdgeDBNDomainName")}
																</span>
															) : (
																// Show dropdown if domain is empty or row is still editable (dirty)
																<select
																	title="Please select a domain name."
																	className="w-full px-2 py-1 border border-blue-500 rounded focus:outline-none focus:ring-2 focus:ring-blue-300"
																	value={getNestedValue(row, column?.field) || ""}
																	onChange={(e) => {
																		const selectedName = e.target.value;
																		const selectedDomain = taxonamyData.find(
																			(d: any) => d.EdgeDBNDomainName === selectedName
																		);

																		if (selectedDomain) {
																			// Mark row as dirty and updated
																			row._isDirty = true;
																			row.isUpdated = true;

																			handleChange(
																				{ target: { value: selectedDomain.EdgeDBNDomainName } },
																				rowIdx,
																				"EdgeDBNDomainName"
																			);
																			handleChange(
																				{ target: { value: selectedDomain.EdgeDBNDomainCode } },
																				rowIdx,
																				"EdgeDBNDomainCode"
																			);
																		}
																	}}
																	onBlur={() => setEditing({ row: null, column: null })}
																	onKeyDown={handleKeyDown}
																	autoFocus
																>
																	<option value="">Select Domain</option>
																	{taxonamyData?.map((domain: any, idx: number) => (
																		<option key={idx} value={domain?.EdgeDBNDomainName}>
																			{domain?.EdgeDBNDomainName}
																		</option>
																	))}
																</select>
															)
														) : column?.field === "EdgeDBNDomainCode" ? (
															getNestedValue(row, "EdgeDBNDomainCode") ? (
																// Show domain code as plain text if exists
																<span
																	className="cursor-default"
																	title={`The domain code "${getNestedValue(row, "EdgeDBNDomainCode")}" is automatically assigned based on the selected domain "${getNestedValue(row, "EdgeDBNDomainName")}".`}
																>
																	{getNestedValue(row, "EdgeDBNDomainCode")}
																</span>
															) : (
																// Placeholder text until domain is selected
																<span
																	className="text-gray-400 italic cursor-default"
																	title="This field will be auto-filled once a domain name is selected."
																>
																	Auto-filled after selecting domain
																</span>
															)
														) : column?.field === "DBNCategories" ? (
															(() => {
																let options: { name: string, code: string }[] = [];

																taxonamyData?.filter((domain: any) => domain?.EdgeDBNDomainName == row['EdgeDBNDomainName'])
																	.map((filteredItems: any) => {
																		filteredItems['EdgeDBNCategories']?.map((item: any) => {
																			options.push({
																				name: item.EdgeDBNCategoryName,
																				code: item.EdgeDBNCategoryCode
																			});
																		});
																	});
																return (
																	<div className="space-y-1">
																		<MultiSelectDropdown
																			options={options}
																			setSelectedRow={setSelectedRow}
																			rowIdx={rowIdx}
																			setActiveRow={setActiveRow}
																			initialSelected={(filteredData?.[rowIdx]?.DBNCategories || [])
																				.map((item: any) => ({
																					name: item?.EdgeDBNCategoryName,
																					code: item?.EdgeDBNCategoryCode
																				}))
																				.filter((item: any) => !!item.name)}
																			onClose={(selectedOptions) => {
																				const updated = [...filteredData];
																				updated[rowIdx]['DBNCategories'] = selectedOptions?.map((item: any) => ({
																					EdgeDBNCategoryName: item.name,
																					EdgeDBNCategoryCode: item.code,
																				}));
																				updated[rowIdx]['isUpdated'] = true;
																				// setData(updated);
																				setFilteredData(updated);
																			}}
																		/>
																	</div>
																);
															})()
														) : (
															<input
																type="text"
																disabled={selectedOption === 'column' && selectedColumn !== column?.label}
																className="w-full px-2 py-1 border border-blue-500 rounded focus:outline-none focus:ring-2 focus:ring-blue-300 disabled:bg-gray-100"
																value={getNestedValue(row, column?.field) || ""}
																onChange={(e) => handleChange(e, rowIdx, column?.field)}
																onBlur={() => setEditing({ row: null, column: null })}
																onKeyDown={handleKeyDown}
																autoFocus
															/>
														)
													) : column?.type === "image" ? (
														<div className="w-12 h-12">
															<img
																src={getNestedValue(row, column?.field) || "/assets/images/product-placeholder.png"}
																alt="Product"
																className="w-full h-full object-contain transform transition-transform duration-300 hover:scale-150"
															/>
														</div>
													) : column?.type === "boolean" ? (
														<div className="flex justify-center items-center cursor-pointer"
															onClick={() => {
																if (typeof column.callback === "function") {
																	column.callback(row);
																}
															}}
														>
															<YesNoRendererComponent
																value={getNestedValue(row, column?.field)}
																data={column}
																dataId={row}
																onClick={() => {
																	const newData = [...filteredData];
																	newData[rowIdx][column?.field] = !newData[rowIdx][column?.field];
																	newData[rowIdx]["isUpdated"] = true;
																	// setData(newData);
																	setFilteredData(newData);
																}}
															/>
														</div>
													) : (
														// <span onClick={() => handleEdit(rowIdx, column?.field)}>
														// 	{getNestedValue(row, column?.field) ?? "-"}
														// </span>
														// <span
														// 	onClick={() => {
														// 		if (column?.isEdit) {
														// 			handleEditAction(row);
														// 		}
														// 		handleEdit(rowIdx, column?.field);
														// 	}}
														// >
														<span
															onClick={() => {
																if (typeof column?.callback === "function") {
																	column.callback(row);
																} else if (column?.isEdit) {
																	handleEditAction(row);
																}
																handleEdit(rowIdx, column?.field);
															}}
															className={
																column?.field === "Combinations"
																	? "text-blue-600 underline cursor-pointer"
																	: ""
															}
														>
															{column.render
																? column.render(row)
																: (() => {
																	const value = getNestedValue(row, column?.field);
																	if (Array.isArray(value)) {
																		return value.length > 0
																			? value?.map((item: any) =>
																				typeof item === "string"
																					? item
																					: item?.Name || item?.EdgeDBNCategoryName || item?.label || JSON.stringify(item)
																			).join(", ")
																			: "-";
																	} else if (typeof value === "object" && value !== null) {
																		return JSON.stringify(value);
																	} else {
																		return value || "-";
																	}
																})()}
														</span>
													)}
												</td>
											) : null
											)}
											{/* End column loop */}

											{/* Action column – outside of columnData.map */}
											{(onEdit || onDelete || onViewList) && (
												<td className="flex p-5 w-max flex-row justify-center items-baseline cursor-pointer">
													<div className="flex items-center space-x-2 w-full">
														{row.isUpdated ? (
															// Show only Clear button if row is updated
															<div className="flex justify-center w-full">
																<svg onClick={() => handleClearRowUpdate(rowIdx)} className="ml-4 cursor-pointer hover:scale-110 transition-transform duration-150" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" color="#e70b0b" fill="none">
																	<title>Clear Row Changes</title>
																	<path d="M19.0005 4.99988L5.00049 18.9999M5.00049 4.99988L19.0005 18.9999" stroke="#e70b0b" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
																</svg>
															</div>
														) : (
															// Show View, Edit, Delete buttons only if not updated
															<>
																{onViewList && (
																	<svg className="ml-1" onClick={() => handleView(row)} width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
																		<title>View Details</title>
																		<path fill="#33363F" fillRule="evenodd" clipRule="evenodd" d="M20.7703 12C20.7703 11.6412 20.5762 11.4056 20.188 10.9343C18.768 9.21014 15.6357 6 12 6C8.36428 6 5.23207 9.21014 3.81198 10.9343C3.42382 11.4056 3.22974 11.6412 3.22974 12C3.22974 12.3588 3.42382 12.5944 3.81198 13.0657C5.23207 14.7899 8.36428 18 12 18C15.6357 18 18.768 14.7899 20.188 13.0657C20.5762 12.5944 20.7703 12.3588 20.7703 12ZM12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3432 9 9.00002 10.3431 9.00002 12C9.00002 13.6569 10.3432 15 12 15Z" />
																	</svg>
																)}
																{onEdit && (
																	<svg xmlns="http://www.w3.org/2000/svg" onClick={() => handleEditAction(row)} width="14" height="14" viewBox="0 0 24 24"	>
																		<title>Edit</title>
																		<path d="M19.045 7.401c.378-.378.586-.88.586-1.414s-.208-1.036-.586-1.414l-1.586-1.586c-.378-.378-.88-.586-1.414-.586s-1.036.208-1.413.585L4 13.585V18h4.413L19.045 7.401zm-3-3 1.587 1.585-1.59 1.584-1.586-1.585 1.589-1.584zM6 16v-1.585l7.04-7.018 1.586 1.586L7.587 16H6zm-2 4h16v2H4z" />
																	</svg>
																)}
																{onDelete && (
																	<div className="pl-2">
																		<svg xmlns="http://www.w3.org/2000/svg" onClick={() => handleClickDelete(row)} width="14" height="14" viewBox="0 0 24 24" fill="currentColor"	>
																			<title>Delete</title>
																			<path d="M17 6H22V8H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V8H2V6H7V3C7 2.44772 7.44772 2 8 2H16C16.5523 2 17 2.44772 17 3V6ZM18 8H6V20H18V8ZM13.4142 13.9997L15.182 15.7675L13.7678 17.1817L12 15.4139L10.2322 17.1817L8.81802 15.7675L10.5858 13.9997L8.81802 12.232L10.2322 10.8178L12 12.5855L13.7678 10.8178L15.182 12.232L13.4142 13.9997ZM9 4V6H15V4H9Z" />
																		</svg>
																		{modal}
																	</div>
																)}
															</>
														)}
													</div>
												</td>
											)}
										</tr>
									))
								) : (
									<tr>
										<td colSpan={columnDataHide?.filter(col => col.visible).length + (onEdit || onDelete || onViewList ? 2 : 1)} className="text-center py-6 text-slate-400 italic">
											No data available
										</td>
									</tr>
								)}
							</tbody>
						</table >
					</div>
					{/* {data?.length !== 0 ? */}
					< div className="flex items-center justify-center w-full gap-8 my-2" >
						<PaginationContainer
							pages={paginationData}
							handleChangeRowsPerPage={setPageSize}
							handleFirstPageButtonClick={() => setPageData(1)}
							handleBackButtonClick={() => setPageData(paginationData?.PageNumber - 1)}
							handleNextButtonClick={() => setPageData(paginationData?.PageNumber + 1)}
							handleLastPageButtonClick={() => setPageData(paginationData?.TotalPages || 1)}
						/>
					</div >
					{/* : ''} */}
				</>
			)
			}
		</div >
	);
};

export default EditableTable;
